export type FieldType = {
    type: string;
    className?: string;
    itemsWithInput?: any;
    items?: any[];
    itemsWithInputNumber?: any[];
    itemsWithInputBetweenNumber?: any;
    itemsWithInputDate?: any;
    itemsWithInputBetweenDate?: any;
    itemsWithInputText?: any;
    form?: any;
    fields?: any[];
    name?: string;
    nameText?: string;
    nameNumber?: string;
    nameBtn?: string;
    nameComp?: string;
    nameFrom?: string;
    nameTo?: string;
    disabled?: boolean;
    label?: string;
    label1?: string;
    labelcheckbox?: string;
    labelFrom?: string;
    labelTo?: string;
    labelAddorn?: string;
    placeholder?: string;
    placeholderFrom?: string;
    placeholderTo?: string;
    initialValue?: string;
    initialValueFrom?: string;
    initialValueTo?: string;
    optionLabel?: string;
    optionValue?: string;
    anchor?: string;
    addorn?: any;
    guide?: boolean;
    mask?: any;
    maxLength?: number
    emptyMessage?: string;
    hideClearButton?: boolean;
    displayTemplate?: Function;
    errors?: any;
    touched?: any;
    url?: any;
    text?: string;
};

export type FormSettingsType = {
    fields?: FieldType[];
    labelPreffix?: string;
    labelSuffix?: string;
    validationSchema?: any;
    submitOnFieldChange?: boolean;
    submitOnKeyEnter?: boolean;
    submitButtonText?: string;
    cancelButtonText?: string;
};

import FormBuilder from './FormBuilder';
export default FormBuilder;
